import { t } from 'i18next';

import subjectsRepository from '@src/subjects/subjectsRepository';

import checkoutModalTypes from '@src/checkout/checkoutModalTypes';
import checkoutLessonRepository from '@src/checkout/lesson/checkoutLessonRepository';
import { currencyToSymbol } from '@src/utils/pricing';

export default class CheckoutLessonPresenter {
  async load(callback) {
    checkoutLessonRepository.load((pm) => {
      const subjectsPm = subjectsRepository.getSubjects();
      const lessonVariants =
        pm.productVariants &&
        pm.productVariants.map(({ id, price, title, sku, currencyCode }) => {
          let lessonType;

          if (sku.substring(0, 2) === 'IL') lessonType = 1;
          if (sku.substring(0, 2) === 'GL') lessonType = 2;

          const label = `${title} (${price} ${currencyToSymbol[currencyCode]})`;

          return {
            id,
            label,
            value: id,
            lessonType,
          };
        });
      const checkoutLessonVm = {
        title: t(checkoutModalTypes.lesson.title),
        id: pm.teacherId,
        calendar: pm.calendar,
        selectedDate: pm.day,
        selectedTime: pm.time,
        teacherAvatarUrl: pm.teacherAvatarUrl,
        teacherName: pm.teacherName,
        teacherSubjects:
          pm.subjects &&
          pm.subjects.map(({ subjectId }) => {
            const subject = subjectsPm.find(
              (subject) => subject.uniqueId === subjectId
            );
            let grades = subject?.taughtForClasses
              ? subject.taughtForClasses.split(',')
              : [];

            if (subject.taughtForStudents === 2) {
              grades.push(
                t('profile.teach1-2') +
                  ' ' +
                  t('qualification.student').toLowerCase()
              );
            } else if (subject.taughtForStudents === 3) {
              grades.push(
                t('profile.teach1-4') +
                  ' ' +
                  t('qualification.student').toLowerCase()
              );
            }
            if (subject.taughtForAdults) {
              grades.push(t('profile.adult'));
            }
            return {
              name: subject?.name || '',
              grades: grades,
            };
          }),
        lessonDay: '',
        lessonTime: 'Time',
        hasLessonTypes: pm.productVariants && pm.productVariants.length > 0,
        lessonTypes:
          lessonVariants && pm.lessonType === 2
            ? lessonVariants.filter((v) => v.lessonType === pm.lessonType)
            : lessonVariants,
        lessonStudentCount: pm.lessonType === 2 && pm.lessonStudentCount,
        lessonMax: pm.lessonMax,
        price: pm.price,
        currency: pm.currency,
      };
      callback(checkoutLessonVm);
    });
  }

  async selectTeacher(teacher) {
    await checkoutLessonRepository.selectTeacher(teacher);
  }

  selectLessonTime({ day, time, lessonType, lessonStudentCount, lessonMax }) {
    checkoutLessonRepository.selectLessonTime({
      day,
      time,
      lessonType,
      lessonStudentCount,
    });
  }

  getSelectedTime() {
    return checkoutLessonRepository.getSelectedTime();
  }
}
